import React, { useMemo, useState } from 'react';
import { formatNumber } from '../Common/CensusMap';
import { TableSkeleton } from '../Common/CensusSkeletons';

// Variáveis do tema com o valor somado da área. Os temas do IBGE têm de dezenas a centenas de
// variáveis, então a tabela tem busca pela descrição e esconde os zerados por padrão.
// `isUpdating`: mostrando os dados anteriores enquanto chegam os da nova área (esmaece em vez de piscar).
function ThemeVariablesTable({ summary, isLoading, isUpdating = false, isError, error }) {
    const [search, setSearch] = useState('');
    const [hideZeros, setHideZeros] = useState(true);

    const rows = useMemo(() => {
        const term = search.trim().toLowerCase();
        return (summary?.variables || []).filter(
            variable =>
                (!hideZeros || variable.value !== 0) &&
                (!term ||
                    variable.description.toLowerCase().includes(term) ||
                    variable.code.includes(term))
        );
    }, [summary, search, hideZeros]);

    if (isLoading) {
        return <TableSkeleton />;
    }
    if (isError) {
        return <div className="censo-notice censo-notice-error">{error.message}</div>;
    }
    if (!summary?.hasData) {
        return (
            <div className="censo-notice">
                Nenhum dado deste tema importado para esta cidade{summary?.year ? ` em ${summary.year}` : ''}.
            </div>
        );
    }

    return (
        <>
            <div className="censo-variables-toolbar">
                <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Buscar variável"
                    aria-label="Buscar variável"
                    value={search}
                    onChange={event => setSearch(event.target.value)}
                />
                <label className="mb-0">
                    <input
                        type="checkbox"
                        checked={hideZeros}
                        onChange={event => setHideZeros(event.target.checked)}
                    />{' '}
                    Ocultar zerados
                </label>
            </div>

            <div className={`censo-variables ${isUpdating ? 'censo-updating' : ''}`} aria-busy={isUpdating}>
                <table className="table table-sm">
                    <tbody>
                        {rows.map(variable => (
                            <tr key={variable.code}>
                                <td>{variable.description}</td>
                                <td>{formatNumber(variable.value)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {!rows.length && <p className="censo-panel-sub">Nenhuma variável encontrada.</p>}
            </div>
            <p className="censo-panel-sub">
                "—": valor sob sigilo do IBGE ou ausente em todos os setores da área.
            </p>
        </>
    );
}

export default ThemeVariablesTable;
